import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { ArrowRight, Check } from 'react-feather';
import { ProOutlineButton } from '../../VuexyDesign/atoms/_index';
import { TextBold24 } from '../common/Text';
import { TextBold14, TextRegular16 } from '../../VuexyDesign/atoms/Text';

import { useIsDesktop } from '../../style/constants';
import { useIsProMember } from '../../api';

const ReleaseTrackUpload = () => {
  const isDesktop = useIsDesktop();
  const isProMember = useIsProMember();
  const { t } = useTranslation('upload');
  return (
    <DistributionCardWrapper
      className={`${isDesktop ? 'ml-1' : ''}`}
      style={{ borderRadius: '23px' }}
    >
      <DistributionCard
        className={`d-flex flex-column align-items-center ${
          isDesktop ? 'p-3' : 'p-2'
        }`}
        style={{ borderRadius: '22px' }}
      >
        <img
          src="/static/images/streamingPlatforms.webp"
          alt="Streaming Platforms"
          width={150}
          height={90}
        />
        <div className="mt-1 d-flex align-items-center">
          <TextBold24 className="mr-1 mb-1">
            {t('upload:releaseATrack') as string}
          </TextBold24>
          <img
            src="/static/images/pro-logo.svg"
            alt="Pro Logo"
            width={40}
            height={19}
          />
        </div>
        <div className="d-flex align-items-center flex-column">
          <div style={{ marginTop: '7px' }}>
            <Check size={14} color="#e51b61" style={{ marginRight: '3px' }} />
            <GradientText className="mr-1">
              {t('upload:keepYourRights') as string}
            </GradientText>
          </div>
          <div>
            <Check size={14} color="#e51b61" style={{ marginRight: '3px' }} />
            <GradientText>{t('upload:earnMoney') as string}</GradientText>
          </div>
        </div>
        <TextRegular16 className="mt-1">
          {t('upload:showcaseYourTalent') as string}
        </TextRegular16>
        <div className="my-1">
          <Link
            href={`${
              isProMember ? '/distribution/welcome' : 'mailto:hello@virpp.com'
            }`}
          >
            <ReleaseButton>
              <>
                {t('upload:releaseNow') as string}
                <GradientArrow size={14} />
              </>
            </ReleaseButton>
          </Link>
        </div>
      </DistributionCard>
    </DistributionCardWrapper>
  );
};

export default ReleaseTrackUpload;

const DistributionCard = styled.div`
  background: linear-gradient(
    135deg,
    rgb(252, 243, 248) 0%,
    rgb(245, 248, 254) 100%
  );
`;
const DistributionCardWrapper = styled.div`
  background: linear-gradient(315.97deg, #1159f1 1.64%, #f41657 100%);
  padding: 2px;
`;

const GradientText = styled(TextBold14)`
  background: linear-gradient(315.97deg, #1159f1 1.64%, #f41657 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const GradientArrow = styled(ArrowRight)`
  color: #5246c5;
`;
const ReleaseButton = styled(ProOutlineButton)`
  &:hover {
    ${GradientArrow} {
      color: white;
    }
  }
`;
